export default {
      id: "oc-menu-setting-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-setting",
      toString: function () {
        return this.url;
      }
    }